import { useEffect, lazy, Suspense, useRef, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useMediaQuery, Box } from '@mui/material';
import { useMotionValueEvent, useScroll } from 'framer-motion';

import { Container } from '~/content/components/Container';
// import { Welcome, Goby, Process, Nike2, Larq, Nike, Reviews, Contact, Delivery } from './components';

import Welcome from './welcome';
import Goby from './goby';
// import Process from './process';
// import Nike2 from './nike2';
// import Larq from './larq';
// import Nike from './nike';
// import Reviews from './reviews';
// import Reviews_STK from './reviews_stk';
// import Contact from '~/content/components/Contact';
// import Delivery from './delivery';
const Process = lazy(() => import('./process.tsx'));
const Nike2 = lazy(() => import('./nike2.tsx'));
const Larq = lazy(() => import('./larq.tsx'));
const Nike = lazy(() => import('./nike.tsx'));
const Reviews = lazy(() => import('./reviews.tsx'));
const Reviews_STK = lazy(() => import('./reviews_stk.tsx'));
const Contact = lazy(() => import('~/content/components/Contact'));
const Delivery = lazy(() => import('./delivery.tsx'));

import { useTranslation } from 'react-i18next';

import p1 from '~/content/images/websites/1.webp';
import p2 from '~/content/images/websites/2.webp';
import p3 from '~/content/images/websites/3.webp';
// import p4 from '~/content/images/websites/4.jpg';
// import p5 from '~/content/images/websites/5.jpg';
import p6 from '~/content/images/websites/6.webp';
// import Backdrop from '@mui/material/Backdrop';
// import { height } from '@mui/system';

import { trackPageview } from '~/utils/plausible';

const Websites = (): JSX.Element => {
	let { t } = useTranslation(['websites']);

	useEffect(() => {
		trackPageview();
	}, []);
	const scrollTo = (id: string): void => {
		setTimeout(() => {
			const element: HTMLElement = document.querySelector(`#${id}`) as HTMLElement;
			if (!element) {
				return;
			}

			window.scrollTo({ left: 0, top: element.offsetTop, behavior: 'smooth' });
		});
	};

	const theme = useTheme();

	const size = '3px';
	const gap = '16px';
	const isSm = useMediaQuery(theme.breakpoints.up('sm'), {
		defaultMatches: true,
	});
	const isMd = useMediaQuery(theme.breakpoints.up('md'), {
		defaultMatches: true,
	});

	const styles = {
		position: 'absolute',
		objectFit: 'cover',
		/* support for plugin https://github.com/bfred-it/object-fit-images */
		// fontFamily: 'object-fit: cover;',
		top: 0,
		left: 0,
		width: '100%',
		height: '100%',
		// zIndex: -1,
		backgroundRepeat: 'no-repeat',
		backgroundSize: 'cover',
		backgroundPosition: 'center center',
		// backgroundImage: `url(${bgImage})`,
		// src: bgImage,
		filter: theme.palette.mode === 'dark' ? 'brightness(0.4)' : 'brightness(0.6) ',
	};

	const Glassmo = () => {
		const ref = useRef(null);
		const { scrollYProgress, scrollY } = useScroll({
			target: ref,
			// offset: ['end end', 'start start'],
			offset: ['start start', 'end end'],
		});

		const [hookedYPostion, setHookedYPosition] = useState(0);
		useMotionValueEvent(scrollYProgress, 'change', (latest) => {
			setHookedYPosition(latest);
		});

		// useEffect(() => {
		//   console.log(hookedYPostion);
		// }, [hookedYPostion]);

		return (
			<>
				<Box
					ref={ref}
					sx={{
						position: 'absolute',
						zIndex: 3,
						top: -30,
						left: 0,
					}}
				/>
				<Box
					sx={{
						backdropFilter: `blur(${hookedYPostion * 50}px)`,
						position: 'absolute',
						top: 0,
						left: 0,
						width: '100%',
						height: '100%',
						zIndex: 3,
					}}
				/>
				{/* scrollYProgress.current: {scrollYProgress.current}
          <br />
          scrollYProgress.hookedYPostion: {hookedYPostion}
          <br /> */}
			</>
		);
	};

	return (
		<>
			<Box
				minHeight={'103vh'}
				display={'flex'}
				alignItems={'center'}
				bgcolor={'alternate.main'}
				marginTop={-13}
				paddingTop={13}
			>
				<Container>
					<Box display={'flex'} flexDirection={'column'} alignItems={'center'}>
						<Welcome />

						<Box marginTop={5}>
							{/* <NoSsr> */}
							<Box
								component={'svg'}
								xmlns='http://www.w3.org/2000/svg'
								viewBox='0 0 24 24'
								fill={theme.palette.primary.main}
								width={{ xs: 30, sm: 40 }}
								height={{ xs: 30, sm: 40 }}
								// onClick={() => scrollTo('agency__portfolio-item--js-scroll')}
								onClick={() => scrollTo('scrollAnker')}
								sx={{ cursor: 'pointer', rel: 'nofollow' }}
							>
								<path
									fillRule='evenodd'
									d='M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z'
									clipRule='evenodd'
								/>
							</Box>
							{/* </NoSsr> */}
						</Box>
					</Box>
				</Container>
			</Box>

			{/* gesundheite */}
			<Box
				position={'relative'}
				minHeight={'100vh'}
				display={'flex'}
				alignItems={'center'}
				id={'scrollAnker'}
			>
				{/* <Glassmo /> */}
				<Box component={'img'} src={p1} alt='Webentwicklung für das Gesundheitswesen' sx={styles} />

				<Container sx={{ position: 'relative', zIndex: 5 }}>
					<Goby />
				</Container>
			</Box>

			{/* kalli yobo */}
			<Box minHeight={'60vh'} display={'flex'} alignItems={'center'} bgcolor={'alternate.main'}>
				<Container>
					<Reviews />
				</Container>
			</Box>

			{/* infrastruktur */}
			<Box position={'relative'} minHeight={'100vh'} display={'flex'} alignItems={'center'}>
				{/* <Glassmo /> */}
				<Box
					component={'img'}
					src={p2}
					alt='Webentwicklung für Infrastruktur und Mobilität'
					sx={styles}
				/>

				<Container
					sx={{
						position: 'relative',
						zIndex: 5,
					}}
				>
					<Larq />
				</Container>
			</Box>

			{/* features */}
			<Box minHeight={'70vh'} display={'flex'} alignItems={'center'} bgcolor={'alternate.main'}>
				<Container>
					<Process />
				</Container>
			</Box>

			{/* behörden */}
			<Box position={'relative'} minHeight={'100vh'} display={'flex'} alignItems={'center'}>
				{/* <Glassmo /> */}
				<Box
					component={'img'}
					src={p3}
					alt='Webentwicklung für Behörden, öffentliche Dienste und Verwaltungen'
					sx={styles}
				/>

				<Container
					sx={{
						position: 'relative',
						zIndex: 5,
					}}
				>
					<Nike />
				</Container>
			</Box>

			{/* bettina stk  */}
			<Box minHeight={'60vh'} display={'flex'} alignItems={'center'} bgcolor={'alternate.main'}>
				<Container>
					<Reviews_STK />
				</Container>
			</Box>

			{/* für deutschland */}
			<Box position={'relative'} minHeight={'100vh'} display={'flex'} alignItems={'center'}>
				{/* <Glassmo /> */}
				<Box
					component={'img'}
					src={p6}
					alt='Webentwicklung für Unternehmen aus Deutschland'
					sx={styles}
				/>
				<Container
					sx={{
						position: 'relative',
						zIndex: 5,
					}}
				>
					<Nike2 />
				</Container>
			</Box>

			{/* umsetzung */}
			<Box
				minHeight={'0vh'}
				display={'flex'}
				alignItems={'center'}
				bgcolor={theme.palette.primary.light}
			>
				<Container sx={{ mb: { xs: 0, sm: 0 }, mt: { xs: 0, sm: 5 } }}>
					<Delivery />
				</Container>
			</Box>
			{/* call to action kontakt */}

			<Box
				minHeight={'0vh'}
				display={'flex'}
				alignItems={'center'}
				bgcolor={theme.palette.primary.light}
			>
				<Container sx={{ mb: { xs: 5, sm: 9 }, mt: { xs: 0, sm: 2 } }}>
					<Contact leftButtonText={t('mini_contact_button_1')} />
				</Container>

				{/* </Box> */}
			</Box>
		</>
	);
};

export default Websites;
